import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_PRODUCTV2_URL } from '../../connection.data';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ProductV2Service extends BasicService {

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_PRODUCTV2_URL;
    }
}